module.exports = __webpack_public_path__ + "images/unit-icons/10x30-parking_space.svg";